import CampaignTemplateSummarySlide from "./CampaignTemplateSummarySlide";

export default CampaignTemplateSummarySlide;
